<template>
  <div :class="['classbutton', classIsActiveas() ? 'active' : '']" @click="toggleClass()">
    <span class="text-slate-500 text-xl font-semibold">{{ fclass }}</span>
    <span class="text-slate-400" v-html="additionalText"></span>
  </div>
</template>

<script setup>
import { defineProps} from 'vue'
import { computed } from 'vue';
import { useStore } from 'vuex';

const props = defineProps({
  fclass: {
    type: String,
    required: true
  },
  additionalText: {
    type: String
  },
})

const store = useStore();
const newDriverLicenceClasses = computed(() => store.state.newDriverLicenceClasses);

const classIsActiveas = () => {
  return newDriverLicenceClasses.value.includes(props.fclass);
}
const toggleClass = () => {
  store.commit("toggleNewDriverLicenceClasses", props.fclass)
}
</script>

<style scoped lang="scss">
.classbutton {
  @apply border border-slate-300 bg-gray-100 cursor-pointer p-4 flex w-fit flex-col rounded-md select-none;
  &.active {
    @apply bg-gray-300;
  }
}
</style>